
export enum AmpEventSourceTypeMarketingCloud {
  MARKETING = 'MARKETING'
}
